module.exports = __webpack_public_path__ + "static/media/gcdef_115.60c4a805.ico";